









import Vue from 'vue'

export default Vue.extend({
  name: 'pilot-loadout-block',
  props: {
    pilot: {
      type: Object,
      required: true,
    },
  },
})
